import { HTMLProps } from 'react'
import clsx from 'classnames'
import useEmblaCarousel from 'embla-carousel-react'
import { useLocale } from 'use-intl'
import { IPostPreview } from '@/interfaces/analytics'
import { IAd } from '@/interfaces/ads'
import { CommentCard } from './comment-card'
import style from './comments.module.scss'

interface CommentsProps extends HTMLProps<HTMLDivElement> {
  loaded?: boolean
  comments: IAd[]
}

export const Comments = ({ className, loaded = false, comments }: CommentsProps) => {
  const currentLocale = useLocale()
  const [emblaRef, emblaApi] = useEmblaCarousel({
    container: `.${style.slides}`,
  })

  const onPrevButtonClick = () => {
    if (!emblaApi) return

    emblaApi.scrollPrev()
  }

  const onNextButtonClick = () => {
    if (!emblaApi) return

    emblaApi.scrollNext()
  }

  return (
    <div
      className={clsx(className, style.container, {
        [style.loaded]: loaded,
      })}
      ref={emblaRef}
    >
      <div className={clsx(style.slides, 'container')}>
        {comments?.map((el, index: number) => {
          return (
            <CommentCard key={index} name={el.title ?? ''} src={el?.image?.url} text={el?.description} link={el.url} />
          )
        })}
      </div>

      <div className={style.nav}>
        <svg className={style.prev} viewBox="0 0 20 20" onClick={onPrevButtonClick}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m6.517 1.265 8.321 7.682v2.106l-8.321 7.682-1.357-1.47 7.678-7.088v-.355L5.16 2.735l1.357-1.47Z"
          />
        </svg>

        <svg className={style.next} viewBox="0 0 20 20" onClick={onNextButtonClick}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m6.517 1.265 8.321 7.682v2.106l-8.321 7.682-1.357-1.47 7.678-7.088v-.355L5.16 2.735l1.357-1.47Z"
          />
        </svg>
      </div>
    </div>
  )
}
